import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link } from 'react-router-dom';

import { api_crud_route, api_list_route, api_crud_base, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../Utils';

import { getTokenInfo } from './../../../UseToken';

export default function List() {



    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    useEffect(() => {
        const companycode = getTokenInfo().companycode;
        const office = getTokenInfo().office.id;


        if (getTokenInfo().profile === 'Master' || getTokenInfo().profile === 'Administrador') {
            reqGET(api_list_route(getTokenInfo().companycode))
                .then(res => { setData(res.data); setLoading(false) })
                .catch(() => 404

                    //  TODO: ENVIAR PÃ�GINA 404
                    //alert(error)); 
                )
        }
        else {

            //reqGET(api_list_route(getTokenInfo().companycode))
            reqGET(`${api_crud_base}/credits/credits/special/office/${companycode}/${office}`)
                .then(res => { setData(res.data); setLoading(false) })
                .catch(() => 404

                    //  TODO: ENVIAR PÃ�GINA 404
                    //alert(error)); 
                )
        }
    }, []);


    //APAGAR REGISTO
    function apagar(id) {
        if (window.confirm('Tem a certeza que quer apagar esta Entidade?')) {

            reqDELETE(api_crud_route, { id: id })
                .then(() => {
                    setLoading(true);
                    alert('Registo Apagado com Sucesso');
                })
                .catch(e => alert('Problema ao Apagar Registo'))
        }
    }

    const columns = [
        {
            name: 'Cliente',
            selector: 'info.Cliente.name',
            sortable: true,
            let: true,
        },
        {
            name: 'NIF',
            selector: 'info.Cliente.vat',
            maxWidth: '150px',
            minWidth: '150px',
            sortable: true,
            left: true,
        },
        {
            name: 'Tipo de Crédito',
            selector: 'info.tipo_credito.name',
            sortable: true,
            left: true,
        },
        {
            name: 'Banco',
            selector: 'info.financials.name',
            sortable: true,
            left: true,
        },
        {
            name: 'Valor',
            cell: row => <div>{row.commissioning.valor_financiado}€</div>,
            maxWidth: '150px',
            minWidth: '150px',
            sortable: true,
            left: true,
        },
        {
            name: '',
            right: true,
            maxWidth: '150px',
            minWidth: '150px',
            export: false,
            //print: false,

            cell: row =>

                <span>

                    <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <img alt='visualizar' src={'./img/view.svg'} />
                    </Link>

                    {/*style={{ display: 'none' }}*/}
                    <Link className="button button-update" to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} style={{ display: '' }} replace>
                        <img alt='editar' src={'./img/editar.svg'} />
                    </Link>


                    <button onClick={() => apagar(row['id'])} className="button btn-delete" style={{ display: 'none' }}>
                        <img alt='apagar' src={'./img/eliminar.svg'} />
                    </button>
                </span >

        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: 'Registos por página:',
        rangeSeparatorText: 'de',
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: 'Todos',
    };


    const tableData = {
        columns,
        data,
        filterPlaceholder: 'Procurar'
    };


    return (isloading ?
        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">LOADING</h2>
                <p>LOADING</p>
                <div className="overlay">
                    <div className="overlay__inner">
                        <div className="overlay__content"><span className="spinner"></span></div>
                    </div>
                </div>

            </div>
        </main>

        :

        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">Créditos</h2>
                <p>Home / Créditos / Lista de Créditos</p>
            </div>

            <div className={`dash-cards-2 body`}>
                <div className="card">
                    <div className="div-table">
                        <div className="table-body">
                            <DataTableExtensions {...tableData}>

                                <DataTable
                                    noDataComponent='Sem Registos'
                                    noHeader
                                    pagination
                                    exportHeaders
                                    paginationComponentOptions={defaultComponentOptions}
                                    paginationPerPage={25}
                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                />
                            </DataTableExtensions>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}